export default "__VITE_ASSET__CLf$ywzW__"